import { Box } from '@mui/material'
import DateRangeIcon from '@mui/icons-material/DateRange'
export function ProgramAllowedYear (props: { text: string }): JSX.Element {
  const color = '#722A82'
  return <Box
    sx={{
      color,
      backgroundColor: color + '1a',
      borderStyle: 'solid',
      borderRadius: 3,
      borderWidth: '1px',
      padding: '8px',
      maxWidth: '180px',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'center'
    }}
  >
    <DateRangeIcon fill={color} />
    {props.text}
  </Box>
}
